import React from 'react'
import { createFromIconfontCN } from '@ant-design/icons'
const IconFont = createFromIconfontCN({
  scriptUrl: '/iconfont.js',
})

interface Props {
  type: string // 图标类型
  rotate?: number // 旋转角度
  className?: string // 样式
  style?: React.CSSProperties // 样式
  spin?: boolean // 是否动画旋转
  onClick?: React.MouseEventHandler<HTMLElement>
}
const CustomIcon = (props: Props) => {
  return (
    <IconFont
      type={props.type}
      rotate={props.rotate}
      spin={props.spin}
      className={props.className}
      style={props.style}
      onClick={props.onClick}
    />
  )
}
export default CustomIcon
import React from 'react'
import { createFromIconfontCN } from '@ant-design/icons'
const IconFont = createFromIconfontCN({
  scriptUrl: '/iconfont.js',
})

interface Props {
  type: string // 图标类型
  rotate?: number // 旋转角度
  className?: string // 样式
  style?: React.CSSProperties // 样式
  spin?: boolean // 是否动画旋转
  onClick?: React.MouseEventHandler<HTMLElement>
}
const CustomIcon = (props: Props) => {
  return (
    <IconFont
      type={props.type}
      rotate={props.rotate}
      spin={props.spin}
      className={props.className}
      style={props.style}
      onClick={props.onClick}
    />
  )
}
export default CustomIcon
